"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWine = exports.isNa = exports.isLiquor = exports.isItemType = exports.isBeerOrNa = exports.isBeer = exports.hasLiquor = exports.hasBeer = exports.getTotalUnits = exports.getTotalAmount = exports.getOrderTotalUnits = exports.getOrderTotalAmount = exports.getMinimumAmountByDeliveryType = exports.getItemType = exports.getFilteredPriceTotal = exports.formatAmount = exports.convertObjectToPlainArray = exports.calculateSpiritVolume = void 0;
var _lodash = require("lodash");
var _constants = require("./product/constants");
var _constants2 = require("./order/constants");
const convertObjectToPlainArray = obj => Object.keys(obj).map(key => obj[key]);
exports.convertObjectToPlainArray = convertObjectToPlainArray;
const getTotalAmount = productArray => productArray.map(item => item.quantity * (item.effective_price ?? (item.last_invoiced_price || item.product_price))).reduce((acc, val) => acc + val, 0).toFixed(2);
exports.getTotalAmount = getTotalAmount;
const getTotalUnits = productArray => productArray.map(item => item.quantity).reduce((acc, val) => acc + val, 0);
exports.getTotalUnits = getTotalUnits;
const getOrderTotalAmount = productArray => productArray.map(item => parseInt(item.qty) * item.price).reduce((acc, val) => acc + val, 0).toFixed(2);
exports.getOrderTotalAmount = getOrderTotalAmount;
const getOrderTotalUnits = (productArray = []) => {
  return productArray.map(item => item.new_qty > 0 ? parseInt(item.new_qty) : parseInt(item.qty)).reduce((acc, val) => acc + val, 0);
};
exports.getOrderTotalUnits = getOrderTotalUnits;
const moneyFormatter = new Intl.NumberFormat("en-US", {
  currency: "USD",
  style: "currency",
  minimumFractionDigits: 2
});
const getFilteredPriceTotal = productArray => {
  const totalPrice = productArray.map(item => parseFloat(item.total)).reduce((acc, val) => acc + val, 0).toFixed(2);
  return formatAmount(totalPrice);
};
exports.getFilteredPriceTotal = getFilteredPriceTotal;
const formatAmount = amount => amount != undefined && amount != null ? moneyFormatter.format(amount) : "";
exports.formatAmount = formatAmount;
const getItemType = item => (0, _lodash.lowerCase)((0, _lodash.get)(item, "product.product_type", null) ?? (0, _lodash.get)(item, "product_type", null));
exports.getItemType = getItemType;
const isItemType = (item, type) => (0, _lodash.isEqual)(getItemType(item), (0, _lodash.lowerCase)(type));
exports.isItemType = isItemType;
const isBeer = item => isItemType(item, _constants.ProductTypes.BEER);
exports.isBeer = isBeer;
const isLiquor = item => isItemType(item, _constants.ProductTypes.LIQUOR);
exports.isLiquor = isLiquor;
const isWine = item => isItemType(item, _constants.ProductTypes.WINE);
exports.isWine = isWine;
const isNa = item => isItemType(item, _constants.ProductTypes.NA);
exports.isNa = isNa;
const isBeerOrNa = item => isBeer(item) || isNa(item);
exports.isBeerOrNa = isBeerOrNa;
const hasLiquor = items => !!items.find(i => isLiquor(i));
exports.hasLiquor = hasLiquor;
const hasBeer = items => !!items.find(i => isBeer(i));
exports.hasBeer = hasBeer;
const calculateSpiritVolume = items => {
  return items.reduce((total, item) => {
    const volume_ml = Number(item.volume_ml ?? (0, _lodash.get)(item, "product.volume_ml")) || 0;
    const quantity = Number(item.quantity ?? item.qty) || 0;
    if (isLiquor(item) && volume_ml > 0 && quantity > 0) {
      return total + volume_ml * quantity;
    }
    return total;
  }, 0);
};
exports.calculateSpiritVolume = calculateSpiritVolume;
const getMinimumAmountByDeliveryType = (company, delivery_type) => {
  const pickupMinimum = Number((company === null || company === void 0 ? void 0 : company.min_pickup_amount) ?? 0);
  const deliveryMinimum = Number((company === null || company === void 0 ? void 0 : company.min_delivery_amount) ?? 0);
  const minimumByDeliveryType = {
    [_constants2.DeliveryTypes.PICKUP]: pickupMinimum,
    [_constants2.DeliveryTypes.DELIVERY]: deliveryMinimum
  };
  return minimumByDeliveryType[delivery_type];
};
exports.getMinimumAmountByDeliveryType = getMinimumAmountByDeliveryType;